// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "PODSUMOWANIE ROKU",
    "note": "* Wszystkie statystyki w tym podsumowaniu pochodzą z dnia 2025/12/31."
  },
  "handCard": {
    "text": "{date}\nTwoja pierwsza rozgrywka w KKPoker miała miejsce w 2025 roku."
  },
  "report": {
    "loginTime": "Od tego czasu KKPoker był z Tobą przez \n{loginDay}",
    "loginTips": "* Liczba dni logowania do KKPoker w 2025 roku.",
    "enjoyTime": "{loginTime}\nto Twoja ulubiona pora dnia! To właśnie wtedy najczęściej otwierasz KKPoker!",
    "firstHandDate": "{first_hand_date}\nTo było Twoje pierwsze rozdanie roku. Odbyło się w {first_hand_type}.\n{first_hand_cards}"
  },
  "hands": {
    "v1": "Liczba rozdań rozegranych w tym roku w KKPoker:\n{hands}\nOdznaczasz się silniejszym zamiłowaniem do pokera niż \n{percentage} graczy.",
    "v2": "Liczba rozdań rozegranych w tym roku w KKPoker:\n{hands}\nDziękujemy za wspólną przygodę!",
    "v3": "Liczba rozdań rozegranych w tym roku w KKPoker: \n{hands}\nW przyszłym roku KKPoker wejdzie na wyższy poziom, by dostarczyć jeszcze lepszych wrażeń z gry."
  },
  "hardTime": {
    "date": "{one_day_hands}\nto był dzień Twojej najintensywniejszej gry w KKPoker.",
    "hands": "Liczba rozegranych tego dnia rozdań:\n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "Ze wszystkich rozegranych rozdań\n{handsNum} odbyło się w Twoim ulubionym formacie: {game}",
  "kkWin": {
    "v1": "Liczba otrzymanych przez Ciebie KK w 2025 roku:\n{all} {longTimes}\nLiczba zwycięstw z KK:\n{win} {longTimesTwo}",
    "v2": "Liczba Twoich zagrań All-in w tym roku:\n{all}\nWspółczynnik wygranych All-in:\n{percentage}\nPoker to gra dla nieustraszonych!"
  },
  "achievement": {
    "spinup": "{spinup_date}\nto był Twój najszczęśliwszy dzień.",
    "spinup_2": "Udało ci się wtedy zdobyć mnożnik SpinUp {spinup_ratio} i wygrać\n{spinup_reward}",
    "mtt": "{mtt_date}\nto był dla Ciebie ważny dzień.",
    "mtt_2": "Tego dnia,\nudało Ci się zająć {mtt_rank}. miejsce w {mtt_name}\ni wygrać\n{mtt_reward}",
    "rg": "{rg_date}\nWyjątkowy dzień w pokerowej przygodzie!",
    "rg_2": "Udało Ci się wtedy wygrać swoją\nnajwiększą w tym roku pulę:\n{rg_reward}"
  },
  "lucky": {
    "title": "Każde rozdanie\nto nowa historia.",
    "luckyHand": "SZCZĘŚLIWE\nROZDANIE",
    "unLuckyHand": "PECHOWE\nROZDANIE",
    "luckyRate": "Współczynnik wygranych\n{lucky_rate}",
    "unLuckyRate": "Współczynnik wygranych\n{unlucky_rate}",
    "luckyText": "{lucky_hand} odegrał rolę bohatera.\nWygrałeś(-aś) w {lucky_rate} przypadków, gdy miałeś(-aś) go przy sobie!",
    "unLuckyText": "Uważaj na {unlucky_hand}…\nWygrywasz z nim tylko w {unlucky_rate} przypadków.",
    "note": "*Kwalifikują się tylko początkowe układy rozdane 10 razy lub więcej."
  },
  "futureStory": "KKPoker nie może się doczekać, by w 2026 roku dopisać kolejne rozdziały tej przygody!",
  "version3": {
    "text": "Niestety, rok 2025 upłynął bez nowych wspomnień w KKPoker.",
    "continue": "Dopisz kolejny rozdział\nswojej historii w KKPoker w 2026 roku!",
    "tips": " * Wszystkie statystyki pochodzą z dnia 2024-12-31."
  },
  "button": {
    "save": "Zapisz obraz",
    "copy": "Skopiuj i udostępnij"
  },
  "unit": {
    "days": "dn",
    "hands": "",
    "longHands": "",
    "longTimes": "",
    "longTimesTwo": "",
    "threeTimes": "",
    "times": "",
    "multiplier": "",
    "num": "",
    "num2": "”",
    "bets": "",
    "skUnits": ""
  },
  "toast": {
    "linkCopied": "Link skopiowany",
    "imageSaved": "Obraz zapisany"
  }
}
  